import { RideReport } from 'data/records'
import { resource, collection, findSelector } from 'data/helpers/apiv3'

const [api, actions] = resource(RideReport, [
  collection.get('journal'),
  collection.get('news')
])

const selectors = {
  ...findSelector(RideReport),
  byUserId: (state, userId) => state.apiv3.rideReport.id.filter(rr => rr.userId === userId),
  byTitleSlug: (state, titleSlug) => state.apiv3.rideReport.id.find(rr => rr.titleSlug === titleSlug),
  bySlug: (state, slug) => state.apiv3.rideReport.id.find(rr => rr.slug === slug)
}

const reducers = {}

const initialState = {}

export {
  api as rideReportApi,
  actions as rideReportActions,
  selectors as rideReportSelectors,
  reducers as rideReportReducers,
  initialState as rideReportInitialState
}
